import { apiRequest, readJsonOrThrow } from "@/api/client";

export async function fetchAssignableUsers(session) {
  const response = await apiRequest("/momo/get-users", {
    session,
  });
  return readJsonOrThrow(response, "Failed to fetch users");
}

export async function updateSubtitlesEnabled(session, userId, subtitlesEnabled) {
  const response = await apiRequest("/momo/get-users/subtitles-enabled", {
    method: "PATCH",
    session,
    body: {
      user_id: userId,
      subtitles_enabled: Boolean(subtitlesEnabled),
    },
  });
  return readJsonOrThrow(response, "Failed to update subtitles preference");
}
